import { Grid, Skeleton } from '@mui/material';
import { Card, CardBody, CardTitle } from '@apigrowfinance/pbolt-card';
import { ChipButton } from '@apigrowfinance/pbolt-chip-button';
import { Restricted } from '@apigrowfinance/pbolt-permission-provider';

import { PhoneDetails } from '@clients/accountsClient';
import { Customer } from '@clients/customersClient';
import AccountHolderChip from '@components/chips/AccountHolderChip';
import { REGULAR_IN_REM } from '@pages/accountDetail/tabs/consts';
import PhoneNumberRow from '@pages/accountDetail/tabs/phoneNumbers/phoneNumber/PhoneNumberRow';
import getEnumTranslation from '@utils/getEnumTranslation';

interface CustomerPhonesRowProps {
    customerDetails?: Customer;
    phoneNumberDetails?: PhoneDetails[];
    isLoading?: boolean;
    handleOnClickAdd?: () => void;
    handleOnClickEdit?: (phoneId: number) => void;
}

const CustomerPhonesRow = ({
    customerDetails,
    phoneNumberDetails = [],
    isLoading,
    handleOnClickAdd,
    handleOnClickEdit,
}: CustomerPhonesRowProps) => {
    return (
        <>
            {phoneNumberDetails?.map((phoneNumber, index) => (
                <Card
                    key={phoneNumber.id}
                    isTopRadiusBorder={false}
                    isGap={false}>
                    {index == 0 && (
                        <>
                            {/*min-height header for chips*/}
                            <CardBody
                                direction="row"
                                minHeight={REGULAR_IN_REM}
                                sx={{ justifyContent: 'end' }}>
                                <Restricted to="create.phoneNumber">
                                    <ChipButton
                                        onClick={handleOnClickAdd}
                                        label={getEnumTranslation('add')}
                                        variant="addMenu"
                                        isLoading={isLoading}
                                        bordered
                                    />
                                </Restricted>
                            </CardBody>
                        </>
                    )}
                    {index == 0 && (
                        <CardTitle>
                            <Grid container sx={{ alignItems: 'center' }}>
                                <Grid item data-testid="printed-name">
                                    {isLoading ? (
                                        <Skeleton width={100} />
                                    ) : (
                                        customerDetails?.printed_name
                                    )}
                                </Grid>
                                {customerDetails?.is_owner && (
                                    <Grid item sx={{ ml: 2 }}>
                                        {isLoading ? (
                                            <Skeleton width={80} />
                                        ) : (
                                            <AccountHolderChip />
                                        )}
                                    </Grid>
                                )}
                            </Grid>
                        </CardTitle>
                    )}

                    <CardBody>
                        <PhoneNumberRow
                            phoneDetails={phoneNumber}
                            isLoading={isLoading}
                            handleOnClickEdit={handleOnClickEdit}
                        />
                    </CardBody>
                </Card>
            ))}
        </>
    );
};

export default CustomerPhonesRow;
